import { Button } from '@App/ui/crypto_exchange/desktop/components/controls/Button'
import s from './styles.module.scss'
import { useAppDispatch } from '@App/hooks'
import { setModal } from '@App/redux/slices/modals/ModalSlice'
import { MODAL_TYPES } from '@App/redux/slices/modals/enums'

export const SendReportButton = () => {
  const dispatch = useAppDispatch()

  return (
    <Button className={s.button} onClick={() => dispatch(setModal({ modalType: MODAL_TYPES.SEND_REPORT_MODAL }))}>
      Send report
    </Button>
  )
}
